import { FAQ, EVENT } from "@/data/site";
import { Mail, MapPin, Instagram } from "lucide-react";
import useDocumentTitle from "@/hooks/useDocumentTitle";

export default function Contact() {
  useDocumentTitle("Kontakt", "Skontaktuj się z nami — mamy!kongres 2027, Warszawa. hej@mamykongres.pl");
  return (
    <div>
      <section className="max-w-5xl mx-auto px-6 lg:px-10 pt-8 pb-16">
        <div className="text-xs uppercase tracking-[0.3em] text-[#E6007A] mb-6">Kontakt</div>
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] mb-8">
          Napisz do <span className="italic text-[#E6007A]">nas</span>.
        </h1>
      </section>

      <section className="max-w-6xl mx-auto px-6 lg:px-10 pb-16 grid md:grid-cols-3 gap-6">
        <div className="rounded-3xl bg-white border border-[#E8E1D9] p-8">
          <Mail className="w-7 h-7 text-[#E6007A] mb-4" />
          <div className="text-sm uppercase tracking-wider text-[#5C534D] mb-2">Email</div>
          <a href="mailto:hej@mamykongres.pl" className="font-display text-2xl hover:text-[#E6007A] transition-colors">
            hej@mamykongres.pl
          </a>
        </div>
        <div className="rounded-3xl bg-white border border-[#E8E1D9] p-8">
          <Instagram className="w-7 h-7 text-[#E6007A] mb-4" />
          <div className="text-sm uppercase tracking-wider text-[#5C534D] mb-2">Instagram</div>
          <a
            href="https://instagram.com/mamy_kongres"
            target="_blank"
            rel="noopener noreferrer"
            className="font-display text-2xl hover:text-[#E6007A] transition-colors"
          >
            @mamy_kongres
          </a>
          <div className="text-sm text-[#5C534D] mt-1">Śledź, pisz, komentuj</div>
        </div>
        <div className="rounded-3xl bg-white border border-[#E8E1D9] p-8">
          <MapPin className="w-7 h-7 text-[#E6007A] mb-4" />
          <div className="text-sm uppercase tracking-wider text-[#5C534D] mb-2">Miejsce</div>
          <div className="font-display text-xl leading-tight">{EVENT.venue}</div>
          <div className="text-sm text-[#5C534D] mt-1">{EVENT.city}</div>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 lg:px-10 pb-24">
        <div className="text-xs uppercase tracking-[0.3em] text-[#E6007A] mb-4">FAQ</div>
        <h2 className="font-display text-4xl md:text-5xl mb-10">Wszystko, co chciałaś wiedzieć</h2>
        <div className="space-y-4">
          {FAQ.map((f, i) => (
            <details key={i} className="rounded-2xl bg-white border border-[#E8E1D9] p-6 group" data-testid={`contact-faq-${i}`}>
              <summary className="cursor-pointer font-semibold text-lg flex justify-between items-center">
                {f.q}
                <span className="text-[#E6007A] text-2xl group-open:rotate-45 transition-transform inline-block">+</span>
              </summary>
              <p className="text-[#5C534D] mt-4 leading-relaxed">{f.a}</p>
            </details>
          ))}
        </div>
      </section>

      <section className="bg-[#F4EFE6] py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <h3 className="font-display text-3xl md:text-4xl mb-6">Bądźmy w kontakcie</h3>
          <div className="flex justify-center gap-3">
            <a href="https://instagram.com/mamy_kongres" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white border border-[#E8E1D9] grid place-items-center hover:bg-[#E6007A] hover:text-white hover:border-[#E6007A] transition-colors" aria-label="Instagram">
              <Instagram className="w-5 h-5" />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
